import React, { Component } from 'react'
import { connect } from 'react-redux'
import { CMSPath, MAP_ENABLED, DEBUG } from '../../../config/constant'
import { getDeliveryLocation, getStoreInfo, sendOrder, setTotalOrderPrice, setSelectedLocation } from '../../../action/hcommerce'
import { closeOrderPopUp, setCustomLocation, setMapSnapshot } from '../../action/hCommerce2'
import { Link } from 'react-router-dom'
import { getGuestInRoom } from '../../../action/action'

class PlaceOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderTime: [],
            timeSelectList: false,
            roomSelectList: false,
            selectedTime: null,
            selectedRoom: null,
            showMap:false
        }
        this.base64Map = null;
    }

    componentDidMount() {
        this.props.getDeliveryLocation(this.props.hcommerceWidget.storeSku);
        if (this.props.serverTime && this.props.serverTime.hours) {
            this.setOrderTime();
        }

        if(this.props.selectedLocation &&  this.props.customLocationLink){
            this.setState({selectedRoom: this.props.selectedLocation.locationNumber});
        }
        this.props.getStoreInfo(this.props.hcommerceWidget.storeSku);
        this.setState({selectedTime: 'Now'})

    }

    componentDidUpdate(preProp,prevState) {
        if (preProp.deliveryLocations !== this.props.deliveryLocations) {
            if (this.props.deliveryLocations.length === 1) {
                this.setState({ 
                    selectedRoom: this.props.deliveryLocations[0].locationNumber,
                    selectedTime: 'Now'
                });
                this.props.setSelectedLocation(this.props.deliveryLocations[0]);
            }else if(this.props.deliveryLocations.length > 1){
                this.props.deliveryLocations.map(obj => {
                    if(obj.defaultLocation == true){
                        this.setState({ 
                            selectedRoom: obj.locationNumber,
                            selectedTime: 'Now'
                        });
                        this.props.setSelectedLocation(obj);
                    }
                })
            }
        }

        /*if(preProp.selectedLocation !== this.props.selectedLocation){
            if(this.props.selectedLocation.mapLocation == false){
                this.base64Map = null;
                this.props.setCustomLocation(null);
            }
        }*/

    }

    setOrderTime = () => {
        let orderTime = [], nextHour;
        if (this.props.serverTime.hours === 23) {
            nextHour = 0;
        } else {
            nextHour = this.props.serverTime.hours + 1;
        }
        if (this.props.serverTime.minutes + 7 > 45) {
            orderTime = [
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:15` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:30` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:45` }
            ]
        } else if (this.props.serverTime.minutes + 7 > 30) {
            orderTime = [
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:45` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:15` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:30` }
            ]
        } else if (this.props.serverTime.minutes + 7 > 15) {
            orderTime = [
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:30` },
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:45` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:15` }
            ]
        } else {
            orderTime = [
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:15` },
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:30` },
                { time: `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:45` },
                { time: `${nextHour < 10 ? `0${nextHour}` : nextHour}:00` }
            ]
        }
        
        var now = { time: 'Now'};
        orderTime.splice(0, 0, now);
        this.setState({ orderTime: orderTime });
    }

    setTimeSelectList = () => {
        this.setState({ timeSelectList: !this.state.timeSelectList });
    }

    setRoomSelectList = () => {
        this.setState({ roomSelectList: !this.state.roomSelectList });
    }

    setSelectedTime = (time) => {
        this.setState({ selectedTime: time, timeSelectList: !this.state.timeSelectList });
    }

    setSelectedroom = (selectedLocation) => {
        this.props.setSelectedLocation(selectedLocation);
        this.setState({ selectedRoom: selectedLocation.locationNumber, roomSelectList: !this.state.roomSelectList });
    }

    placeOrder = () => {
        let selectedGuestDetail = {};
        let tempAddOn = [], tempObj, orderItemList = []
        if (this.props.CheckedInGuest.length > 0) {
            this.props.CheckedInGuest.map((iterator) => {
                if (iterator.guestName === this.props.guestDetail.guestName) {
                    selectedGuestDetail = iterator
                }
            })
        } else {
            console.log("No Guest name slected.");
        }

        if (this.props.savedOrders.length > 0) {
            this.props.savedOrders.map((iterator) => {
                iterator.addOns.map((addOnIterator) => {
                    tempAddOn.push({ "itemAddonId": addOnIterator.id, "itemPrice": addOnIterator.price })
                })
                tempObj = {
                    "storeItemId": iterator.item.id,
                    "quantity": iterator.quantity,
                    "pricePerItem": iterator.item.itemPrice,
                    "guestComment": null,
                    "addOns": tempAddOn
                }
                orderItemList.push(tempObj);
            })
            console.log("orderItemList", orderItemList)
        } else {
            console.log("please select the food which you want to order.");
            this.props.closeOrderPopUp(true, "Can't Place The Order,", "No Item is selected to order.");
        }

        console.log(this.state.selectedTime);
        
        var selectedTimeTemp = '';
        if (this.state.selectedTime === 'Now') {
            selectedTimeTemp = `${this.props.serverTime.hours < 10 ? `0${this.props.serverTime.hours}` : this.props.serverTime.hours}:${this.props.serverTime.minutes}`;
        }
        else {
            selectedTimeTemp = this.state.selectedTime;
        }

        // console.log("this.props.currentWidget",this.props.currentWidget)

        /*if(this.props.selectedLocation && this.state.selectedRoom){
            if (this.props.selectedLocation.mapLocation == true && (!this.base64Map || !this.props.customLocationLink)){
                if(DEBUG){
                    alert("map location is not set");
                    console.log("map location is not set")
                }else{
                    console.log("map location is not set")
                }
                return;
            }
        }*/

        if (this.state.selectedRoom && selectedGuestDetail.id && this.state.selectedTime && this.props.savedOrders.length > 0) {
            this.props.sendOrder(
                this.state.selectedRoom,
                selectedGuestDetail,
                selectedTimeTemp, null,
                this.state.savedOrders,
                this.props.hcommerceWidget,
                orderItemList,
                this.base64Map,
                this.props.customLocationLink,
                this.callBackFromOrderAPI
            );
        } else {
            console.log("All details are not there.");
        }
    }


    callBackFromOrderAPI = (status) => {
        if (status) {
            this.props.closeOrderPopUp(true, "Thank You!", "Your order has been placed.");
            localStorage.setItem("savedOrders", "");
            this.props.setTotalOrderPrice(0);
            this.base64Map = null;
            this.props.setCustomLocation(null);
            this.props.setMapSnapshot(null)
        } else {
            this.props.closeOrderPopUp(true, "Sorry", "Not Able to place your order.");
        }
    }

    mapImageToDataUrl = (img) => {

        console.log("mapImageToDataUrl called")

        const c = document.createElement('canvas')
        c.height = img.height;
        c.width = img.width;
        const ctx = c.getContext('2d');

        ctx.drawImage(img, 0, 0, c.width, c.height);
        const base64 = c.toDataURL();
        this.base64Map = base64;

        // console.log("map image to data url",base64);
    }


    render() {
        return (

            <div class="orders-body-container">
                <div class="orders-body" style = {{height:"20rem"}}>
                    <div id="deliveryTime" class="form-row">
                        {console.log('displayDeliveyTime',this.props.storeInfo),
                        this.props.storeInfo ? 
                            this.props.storeInfo.displayDeliveyTime ? 
                            <div>
                                <label for="del-pref">Delivery Time</label>
                                    <div class="custom-select">
                                        <div className="select-selected select-arrow-active" onClick={this.setTimeSelectList}>
                                            {
                                            this.state.selectedTime ? 
                                            
                                            this.state.selectedTime
                                            : 
                                            "Please select"
                                            }
                                        </div>
                                        <div className={
                                            this.state.timeSelectList ?
                                                "select-items" : "select-items select-hide"
                                        }>
                                            {
                                                this.state.orderTime.map((iterator) => {
                                                    return (
                                                        <div
                                                            onClick={() => this.setSelectedTime(iterator.time)}>
                                                            {iterator.time}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                            </div>    
                                
                            : null
                            
                        : null
                        }
                       
                    </div>
                    <div class="form-row">
                        <label for="room-number">Deliver To</label>
                        {/* <input type="text" name="room-number" id="room-number" value="301" /> */}
                        <div class="custom-select">
                            <div className="select-selected select-arrow-active" onClick={this.setRoomSelectList}>
                                {this.state.selectedRoom ? this.state.selectedRoom : "Please select"}
                            </div>
                            <div className={
                                this.state.roomSelectList ?
                                    "select-items" : "select-items select-hide"
                            }>
                                {
                                    this.props.deliveryLocations.map((iterator) => {
                                        /*if(!iterator.mapLocation){
                                            return(<div onClick={() => this.setSelectedroom(iterator.locationNumber)}>
                                                {iterator.locationNumber}
                                            </div>)
                                        }else{*/
                                        if (MAP_ENABLED){
                                            return(<Link exact to = "/hcommerce2/custom_location">
                                                <div onClick={() => this.setSelectedroom(iterator)}>
                                                    {iterator.locationNumber}
                                                </div>
                                            </Link>)
                                        } else {
                                            return <div onClick={() => this.setSelectedroom(iterator)}>
                                                    {iterator.locationNumber}
                                                </div>
                                        }
                                        
                                        
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    {this.props.customLocationLink && <div class="form-row" style = {{overflowY: "scroll"}}>
                        <label>Selected location</label>
                        {/* <a href = {this.props.customLocationLink}>{this.props.customLocationLink}</a> */}
                        <img onLoad = {(e) => this.mapImageToDataUrl(e.target)} id = "custom_location_img" src = {this.props.mapSnapshot} style = {{marginTop: "2rem", height:"200px",objectFit:"contain",backgroundColor:"#000"}}/>
                    </div>}
                </div>
                <div class="controls">
                    <input className="inputSubmit" onClick={this.placeOrder} type="submit" name="place order" value="Place Order" />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        // currentPage: state.store.Hcommerce.currentPage,
        serverTime: state.store.home.serverTimeDate.time,
        CheckedInGuest: state.store.CheckedInGuest,
        currentWidget: state.store.sideNavBar.currentWidget,
        // serverDate: state.store.home.serverTimeDate,
        deliveryLocations: state.store.Hcommerce.deliveryLocations,
        storeInfo: state.store.Hcommerce.getStoreInfo,
        // menuColor: state.store.home.MenuColor,
        currencyCode: state.store.home.clientConfig.currencyDetails ?
            state.store.home.clientConfig.currencyDetails.code : "",
        totalPrice: state.store.Hcommerce.totalPrice,
        selectedLocation: state.store.Hcommerce.selectedLocation,
        customLocationLink: state.store2.locationLink,
        mapSnapshot: state.store2.mapSnapshot,
        hcommerceWidget: state.store2.hcommerceWidget
    }
}

export default connect(
    mapStateToProps,
    {
        // changePage,
        sendOrder,
        // popupOpenClose,
        // setLoadingMass,
        getDeliveryLocation,
        // setOrderDetailPage,
        closeOrderPopUp,
        setTotalOrderPrice,
        setCustomLocation,
        setSelectedLocation,
        getStoreInfo,
        setMapSnapshot
    }
)(PlaceOrder);